export default __webpack_public_path__ + "static/media/expand_arrow.291e028f.svg";